import React from 'react';

const Pagination = (props) => {
  var { pagination, onPageChange } = props;
  var { page, totalPages, total, limit } = pagination;
  var start = (page - 1) * limit + 1;
  var end = Math.min(page * limit, total);
  if (totalPages <= 1) return null;

  var getPages = function () {
    var pages = [];
    var maxVisible = 5;
    var startPage = Math.max(1, page - Math.floor(maxVisible / 2));
    var endPage = Math.min(totalPages, startPage + maxVisible - 1);
    if (endPage - startPage + 1 < maxVisible) startPage = Math.max(1, endPage - maxVisible + 1);
    for (var i = startPage; i <= endPage; i++) pages.push(i);
    return pages;
  };

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-3 mt-4">
      <p className="text-sm text-gray-600">
        Showing <span className="font-medium">{start}</span> to <span className="font-medium">{end}</span> of <span className="font-medium">{total}</span>
      </p>
      <div className="flex items-center gap-1">
        <button onClick={() => onPageChange(page - 1)} disabled={page === 1} className="p-2 rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition">←</button>
        {getPages().map(function (p) {
          return (
            <button
              key={p}
              onClick={() => onPageChange(p)}
              className="px-3 py-1.5 rounded-lg text-sm font-medium transition"
              style={p === page ? { backgroundColor: '#25D366', color: 'white' } : { border: '1px solid #D1D5DB', color: '#374151' }}
            >
              {p}
            </button>
          );
        })}
        <button onClick={() => onPageChange(page + 1)} disabled={page === totalPages} className="p-2 rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition">→</button>
      </div>
    </div>
  );
};

export default Pagination;